<div>
    <div *ngIf="loading">
        <app-spinner></app-spinner>
    </div>
    <div class="alert alert-danger" *ngIf="!loading && error">
        {{documentsListErrorMessage}}
    </div>
    <div class="alert alert-info" *ngIf="!loading && !error && (documents === null || documents.length < 1)">
        {{documentsListNoDocumentsMessage}}
    </div>
    <table class="table table-striped" *ngIf="!loading && documents && documents.length > 0">
        <thead>
            <tr>
                <th>Documents</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let document of documents">
                <td>
                    <a href="{{document.url}}" target="_blank">
                        <i class="table__icon fa fa-file-text-o" aria-hidden="true"></i>
                        {{document.name}}
                    </a>
                </td>
            </tr>
        </tbody>
    </table>
</div>